import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, mergeProps as _mergeProps, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/MSQ-horizontal-transparent-black.png'
import _imports_1 from '@/assets/MSQ-horizontal-transparent-yellow.png'


const _hoisted_1 = {
  key: 0,
  class: "dashboard-nav"
}
const _hoisted_2 = {
  key: 0,
  src: _imports_0,
  class: "dashboard-logo py-1",
  alt: "Mission Squad Logo"
}
const _hoisted_3 = {
  key: 1,
  src: _imports_1,
  class: "dashboard-logo my-2",
  alt: "Mission Squad Logo"
}
const _hoisted_4 = { class: "dashboard-actions" }
const _hoisted_5 = {
  key: 0,
  src: _imports_0,
  class: "max-width-100 max-height-75px",
  alt: "Mission Squad Logo"
}
const _hoisted_6 = {
  key: 1,
  src: _imports_1,
  class: "max-width-100 max-height-75px",
  alt: "Mission Squad Logo"
}
const _hoisted_7 = {
  key: 0,
  src: _imports_0,
  class: "landing-nav-logo",
  alt: "Mission Squad Logo"
}
const _hoisted_8 = {
  key: 1,
  src: _imports_1,
  class: "landing-nav-logo",
  alt: "Mission Squad Logo"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_OptionsDialog = _resolveComponent("OptionsDialog")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!

  return (_openBlock(), _createBlock(_component_v_app_bar, {
    app: "",
    density: _ctx.appBarDensity,
    height: _ctx.appBarHeight,
    color: "background"
  }, {
    default: _withCtx(() => [
      (_ctx.isDashboard)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_router_link, {
              to: _ctx.defaultDashboardPath,
              class: "dashboard-logo-link"
            }, {
              default: _withCtx(() => [
                (_ctx.currentTheme === 'light')
                  ? (_openBlock(), _createElementBlock("img", _hoisted_2))
                  : (_openBlock(), _createElementBlock("img", _hoisted_3))
              ]),
              _: 1
            }, 8, ["to"]),
            _createVNode(_component_v_tabs, {
              modelValue: _ctx.tab,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tab) = $event)),
                _ctx.tabUpdated
              ],
              color: "primary",
              "bg-color": "background",
              class: "dashboard-tabs",
              density: "compact",
              height: "40",
              "show-arrows": ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleTabs, (t) => {
                  return (_openBlock(), _createBlock(_component_v_tab, {
                    key: t.value,
                    value: t.value
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(t.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "onUpdate:modelValue"]),
            _createElementVNode("div", _hoisted_4, [
              (_ctx.showGlobalTooltips)
                ? (_openBlock(), _createBlock(_component_v_tooltip, {
                    key: 0,
                    location: "bottom"
                  }, {
                    activator: _withCtx(({ props: tooltip }) => [
                      _createVNode(_component_v_btn, _mergeProps({
                        icon: "",
                        variant: "plain",
                        color: "primary",
                        density: "compact",
                        class: "dashboard-action-button",
                        onClick: _ctx.openConfigChat
                      }, tooltip), {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => _cache[10] || (_cache[10] = [
                              _createTextVNode("mdi-robot-outline")
                            ])),
                            _: 1,
                            __: [10]
                          })
                        ]),
                        _: 2
                      }, 1040, ["onClick"])
                    ]),
                    default: _withCtx(() => [
                      _cache[11] || (_cache[11] = _createElementVNode("span", null, "Configuration Assistant", -1))
                    ]),
                    _: 1,
                    __: [11]
                  }))
                : (_openBlock(), _createBlock(_component_v_btn, {
                    key: 1,
                    icon: "",
                    variant: "plain",
                    color: "primary",
                    density: "compact",
                    class: "dashboard-action-button",
                    onClick: _ctx.openConfigChat
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => _cache[12] || (_cache[12] = [
                          _createTextVNode("mdi-robot-outline")
                        ])),
                        _: 1,
                        __: [12]
                      })
                    ]),
                    _: 1
                  }, 8, ["onClick"])),
              _createVNode(_component_v_menu, {
                modelValue: _ctx.dashboardMenuOpen,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dashboardMenuOpen) = $event)),
                location: "bottom end",
                "close-on-content-click": false,
                eager: ""
              }, {
                activator: _withCtx(({ props }) => [
                  _createVNode(_component_v_btn, _mergeProps({ icon: "" }, props, {
                    variant: "plain",
                    color: "primary",
                    density: "compact",
                    class: "dashboard-action-button"
                  }), {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["hamburger", { 'is-active': _ctx.dashboardMenuOpen }])
                      }, _cache[13] || (_cache[13] = [
                        _createElementVNode("span", { class: "hamburger-line" }, null, -1),
                        _createElementVNode("span", { class: "hamburger-line" }, null, -1),
                        _createElementVNode("span", { class: "hamburger-line" }, null, -1)
                      ]), 2)
                    ]),
                    _: 2
                  }, 1040)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_list, {
                    density: "compact",
                    "min-width": "280",
                    class: "nav-menu-list"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item, {
                        "prepend-icon": _ctx.currentTheme === 'light' ? 'mdi-weather-sunny' : 'mdi-weather-night',
                        title: _ctx.currentTheme === 'light' ? 'Dark Mode' : 'Light Mode',
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectTheme(_ctx.currentTheme === 'light' ? 'dark' : 'light')))
                      }, {
                        append: _withCtx(() => [
                          _createVNode(_component_v_switch, {
                            "model-value": _ctx.currentTheme === 'light',
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectTheme($event ? 'light' : 'dark'))),
                            color: "primary",
                            inset: "",
                            flat: "",
                            "hide-details": "",
                            density: "compact",
                            class: "nav-menu-switch",
                            onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
                          }, null, 8, ["model-value"])
                        ]),
                        _: 1
                      }, 8, ["prepend-icon", "title"]),
                      _createVNode(_component_v_list_item, {
                        "prepend-icon": "mdi-information-outline",
                        title: _ctx.showGlobalTooltips ? 'Tooltips (on)' : 'Tooltips (off)',
                        onClick: _ctx.toggleGlobalTooltips
                      }, {
                        append: _withCtx(() => [
                          _createVNode(_component_v_switch, {
                            "model-value": _ctx.showGlobalTooltips,
                            "onUpdate:modelValue": _ctx.toggleGlobalTooltips,
                            color: "primary",
                            inset: "",
                            flat: "",
                            "hide-details": "",
                            density: "compact",
                            class: "nav-menu-switch",
                            onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
                          }, null, 8, ["model-value", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }, 8, ["title", "onClick"]),
                      _createVNode(_component_v_list_item, {
                        "prepend-icon": _ctx.userMode === 'simple' ? 'mdi-tune-variant' : 'mdi-rocket-launch-outline',
                        title: _ctx.userMode === 'simple' ? 'Switch to Advanced' : 'Switch to Simple',
                        onClick: _ctx.toggleUserMode
                      }, null, 8, ["prepend-icon", "title", "onClick"]),
                      _createVNode(_component_v_divider, { class: "my-1" }),
                      _createVNode(_component_v_list_item, {
                        onClick: _ctx.openAgentWizard,
                        "prepend-icon": "mdi-wizard-hat",
                        title: "Agent Wizard"
                      }, null, 8, ["onClick"]),
                      _createVNode(_component_v_list_item, {
                        onClick: _ctx.openOptions,
                        "prepend-icon": "mdi-cog-outline",
                        title: "Options"
                      }, null, 8, ["onClick"]),
                      _createVNode(_component_v_divider, { class: "my-1" }),
                      (_ctx.authenticated)
                        ? (_openBlock(), _createBlock(_component_v_list_item, {
                            key: 0,
                            onClick: _ctx.navigateToDocs,
                            "prepend-icon": "mdi-help-circle-outline",
                            title: "Documentation"
                          }, null, 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      (_ctx.authenticated && _ctx.stripeEnabled)
                        ? (_openBlock(), _createBlock(_component_v_list_item, {
                            key: 1,
                            onClick: _ctx.navigateToSubscription,
                            "prepend-icon": "mdi-credit-card-outline",
                            title: "Subscription"
                          }, null, 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      (_ctx.isAdmin)
                        ? (_openBlock(), _createBlock(_component_v_list_item, {
                            key: 2,
                            onClick: _ctx.navigateToAdmin,
                            "prepend-icon": "mdi-shield-crown",
                            title: "Admin"
                          }, null, 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_divider, { class: "my-1" }),
                      _createVNode(_component_v_list_item, {
                        onClick: _ctx.navigateToAccount,
                        "prepend-icon": "mdi-account-outline"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Account (" + _toDisplayString(_ctx.username) + ")", 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_v_list_item, {
                        onClick: _ctx.signOut,
                        "prepend-icon": "mdi-logout",
                        title: "Sign Out"
                      }, null, 8, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]))
        : (_openBlock(), _createBlock(_component_v_row, {
            key: 1,
            class: _normalizeClass({ 'ma-0': _ctx.isLanding })
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                class: _normalizeClass({ 'pa-0': _ctx.isLanding })
              }, {
                default: _withCtx(() => [
                  (!_ctx.isLanding)
                    ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            class: "col-center"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_router_link, {
                                to: "/",
                                class: _normalizeClass({ 'logo-link-text': _ctx.currentTheme === 'light' })
                              }, {
                                default: _withCtx(() => [
                                  (_ctx.currentTheme === 'light')
                                    ? (_openBlock(), _createElementBlock("img", _hoisted_5))
                                    : (_openBlock(), _createElementBlock("img", _hoisted_6))
                                ]),
                                _: 1
                              }, 8, ["class"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_row, {
                    class: _normalizeClass(_ctx.isLanding ? 'ma-0' : 'mt-0')
                  }, {
                    default: _withCtx(() => [
                      (_ctx.isLanding)
                        ? (_openBlock(), _createBlock(_component_v_col, {
                            key: 0,
                            class: "background d-flex align-center py-0 pl-4"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_router_link, {
                                to: "/",
                                class: "landing-logo-link"
                              }, {
                                default: _withCtx(() => [
                                  (_ctx.currentTheme === 'light')
                                    ? (_openBlock(), _createElementBlock("img", _hoisted_7))
                                    : (_openBlock(), _createElementBlock("img", _hoisted_8))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (!_ctx.isLanding && _ctx.shouldHide(['xs','sm','md']))
                        ? (_openBlock(), _createBlock(_component_v_col, {
                            key: 1,
                            xxl: "2",
                            xl: "2",
                            lg: "2",
                            md: "1",
                            sm: "1",
                            xs: "1",
                            class: "background"
                          }))
                        : _createCommentVNode("", true),
                      (!_ctx.isLanding)
                        ? (_openBlock(), _createBlock(_component_v_col, {
                            key: 2,
                            xxl: "8",
                            xl: "8",
                            lg: "8",
                            md: "10",
                            sm: "9",
                            xs: "12",
                            class: "background banner-text px-4"
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_col, {
                        xxl: "2",
                        xl: "2",
                        lg: "2",
                        md: "2",
                        sm: "3",
                        xs: "3",
                        class: "background pr-4 nav-links d-flex align-center justify-end py-0"
                      }, {
                        default: _withCtx(() => [
                          (!_ctx.authenticated)
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 0,
                                to: "/sign-in",
                                class: "mr-2 sign-in-dashboard-link"
                              }, {
                                default: _withCtx(() => _cache[14] || (_cache[14] = [
                                  _createTextVNode("Sign in")
                                ])),
                                _: 1,
                                __: [14]
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.authenticated)
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 1,
                                to: _ctx.defaultDashboardPath,
                                class: "mr-2 sign-in-dashboard-link"
                              }, {
                                default: _withCtx(() => _cache[15] || (_cache[15] = [
                                  _createTextVNode("Dashboard")
                                ])),
                                _: 1,
                                __: [15]
                              }, 8, ["to"]))
                            : _createCommentVNode("", true),
                          _createVNode(_component_v_menu, {
                            modelValue: _ctx.pageMenuOpen,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.pageMenuOpen) = $event)),
                            location: "bottom end",
                            "close-on-content-click": false,
                            eager: ""
                          }, {
                            activator: _withCtx(({ props }) => [
                              _createVNode(_component_v_btn, _mergeProps({ icon: "" }, props, {
                                variant: "plain",
                                color: "primary"
                              }), {
                                default: _withCtx(() => [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["hamburger", { 'is-active': _ctx.pageMenuOpen }])
                                  }, _cache[16] || (_cache[16] = [
                                    _createElementVNode("span", { class: "hamburger-line" }, null, -1),
                                    _createElementVNode("span", { class: "hamburger-line" }, null, -1),
                                    _createElementVNode("span", { class: "hamburger-line" }, null, -1)
                                  ]), 2)
                                ]),
                                _: 2
                              }, 1040)
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_v_list, {
                                density: "compact",
                                "min-width": "280",
                                class: "nav-menu-list"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item, {
                                    "prepend-icon": _ctx.currentTheme === 'light' ? 'mdi-weather-sunny' : 'mdi-weather-night',
                                    title: _ctx.currentTheme === 'light' ? 'Dark Mode' : 'Light Mode',
                                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.selectTheme(_ctx.currentTheme === 'light' ? 'dark' : 'light')))
                                  }, {
                                    append: _withCtx(() => [
                                      _createVNode(_component_v_switch, {
                                        "model-value": _ctx.currentTheme === 'light',
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectTheme($event ? 'light' : 'dark'))),
                                        color: "primary",
                                        inset: "",
                                        flat: "",
                                        "hide-details": "",
                                        density: "compact",
                                        class: "nav-menu-switch",
                                        onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
                                      }, null, 8, ["model-value"])
                                    ]),
                                    _: 1
                                  }, 8, ["prepend-icon", "title"]),
                                  (_ctx.authenticated)
                                    ? (_openBlock(), _createBlock(_component_v_divider, {
                                        key: 0,
                                        class: "my-1"
                                      }))
                                    : _createCommentVNode("", true),
                                  (_ctx.authenticated)
                                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                                        key: 1,
                                        onClick: _ctx.navigateToDocs,
                                        "prepend-icon": "mdi-help-circle-outline",
                                        title: "Documentation"
                                      }, null, 8, ["onClick"]))
                                    : _createCommentVNode("", true),
                                  (_ctx.authenticated && _ctx.stripeEnabled)
                                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                                        key: 2,
                                        onClick: _ctx.navigateToSubscription,
                                        "prepend-icon": "mdi-credit-card-outline",
                                        title: "Subscription"
                                      }, null, 8, ["onClick"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["class"])
                ]),
                _: 1
              }, 8, ["class"])
            ]),
            _: 1
          }, 8, ["class"])),
      _createVNode(_component_OptionsDialog)
    ]),
    _: 1
  }, 8, ["density", "height"]))
}